// hooks/useSearchHistory.js
import { useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';

export const useSearchHistory = () => {
  const [searchHistory, setSearchHistory] = useLocalStorage('searchHistory', []);
  const [selectedHistoryIndex, setSelectedHistoryIndex] = useLocalStorage('selectedHistoryIndex', -1);

  const removeHistory = useCallback(() => {
    setSearchHistory([]);
    setSelectedHistoryIndex(-1);
    localStorage.removeItem('searchHistory');
    localStorage.removeItem('selectedHistoryIndex');
    localStorage.removeItem('currentSubcategoryData');
    localStorage.removeItem('subStateDataCache');
    localStorage.removeItem('subCompanyCache')
    localStorage.removeItem('subAlertCache');
    localStorage.removeItem('dashboardFilters');
    localStorage.removeItem('subuserDataCache');
  }, [setSearchHistory, setSelectedHistoryIndex]);

  const saveToHistory = useCallback((searchParams, totalCounts) => {
    const historyItem = {
      id: Date.now(),
      params: searchParams,
      timestamp: new Date().toLocaleString(),
      total_counts: totalCounts
    };
    const updatedHistory = [...searchHistory, historyItem].slice(0, 10);
    setSearchHistory(updatedHistory);
    setSelectedHistoryIndex(updatedHistory.length - 1);
  }, [searchHistory, setSearchHistory, setSelectedHistoryIndex]);

  const clearHistory = useCallback(() => {
    removeHistory();
  }, [removeHistory]);

  const deleteHistoryItem = useCallback((id) => {
    const deletedIndex = searchHistory.findIndex(h => h.id === id);
    const newHistory = searchHistory.filter(h => h.id !== id);
    setSearchHistory(newHistory);
    // Adjust selected index after deletion
    if (newHistory.length === 0) {
      setSelectedHistoryIndex(-1);
    } else if (deletedIndex <= selectedHistoryIndex) {
      setSelectedHistoryIndex(Math.max(0, selectedHistoryIndex - 1));
    }
  }, [searchHistory, setSearchHistory, selectedHistoryIndex, setSelectedHistoryIndex]);

  return {
    searchHistory,
    saveToHistory,
    clearHistory,
    deleteHistoryItem,
    selectedHistoryIndex,
    setSelectedHistoryIndex
  };
};